import { HUB_PLACES, type PlaceId } from './hub-model';

/**
 * The simple 2D map of the island (low-graphics mode and the fallback when 3D is unavailable).
 * A flat illustration only: the place buttons are drawn on top by HubPage at the same positions
 * (`HubPlace.map`), so both modes share one set of controls.
 */

const TONE_FILL: Record<string, string> = {
  story: '#ea8a44',
  science: '#2876a7',
  creative: '#a46e46',
  nature: '#4f9a5a',
  broadcaster: 'var(--color-broadcaster)',
};

export function IslandMap({ focused }: { focused: PlaceId }) {
  return (
    <svg
      className="island-map"
      viewBox="0 0 100 60"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      data-testid="island-map"
    >
      <rect width="100" height="60" fill="#7fbfd8" />
      <path
        d="M14 34 C10 18 30 6 50 7 C72 8 92 16 88 34 C85 50 66 56 48 55 C28 54 17 48 14 34Z"
        fill="#ecdcb0"
      />
      <path
        d="M18 33 C15 20 32 10 50 11 C70 12 86 19 83 33 C81 46 65 51 48 50 C31 49 20 44 18 33Z"
        fill="#93c47d"
      />
      {HUB_PLACES.map((p) => {
        const x = p.map.left;
        const y = (p.map.top / 100) * 60;
        return (
          <g key={p.id}>
            <line
              x1="50"
              y1="31"
              x2={x}
              y2={y}
              stroke="#d9ccae"
              strokeWidth="1.6"
              strokeLinecap="round"
            />
            <circle
              cx={x}
              cy={y}
              r={p.id === focused ? 5.4 : 4.4}
              fill={TONE_FILL[p.tone]}
              stroke={p.id === focused ? '#126f68' : '#ffffff'}
              strokeWidth={p.id === focused ? 1.2 : 0.6}
            />
          </g>
        );
      })}
      <circle cx="50" cy="31" r="3" fill="#e3d8bf" />
    </svg>
  );
}
